import React, { useEffect, useState } from "react";
import { Card } from "reactstrap";
import { Image, H6 } from "../../../AbstractElements";

const CabDetails = ({
  element,
  setCarDetails,
  carDetails,
  estimatedData,
  selectedCoupon,
  setSelectedCoupon,
  couponApply,
  selectedOffer,
  offerApply,
  editTrip,
}) => {
  const [noOfCars, setNoOfCars] = useState(1);
  const [selectFlag, setSelectFlag] = useState(false);
  const [carFareEstimate, setCarFareEstimate] = useState({});
  useEffect(() => {
    if (carDetails.length == 0) {
      setSelectFlag(false);
      return;
    }
    const carObj = carDetails[0];
    if (carObj.id == element.id) {
      setSelectFlag(true);
      setNoOfCars(carObj.count);
    } else {
      setSelectFlag(false);
    }
  }, [carDetails]);

  useEffect(() => {
    const carObj = estimatedData.find(
      (estdata) => estdata.carTypeId == element.id
    );
    if (carObj) {
      setCarFareEstimate(carObj);
    } else {
      setCarFareEstimate({});
    }
  }, [estimatedData]);

  const selectCab = () => {
    setCarDetails([
      {
        id: element.id,
        estimatedMinFare: carFareEstimate.estimatedMinFare,
        estimatedMinKM: carFareEstimate.estimatedMinKM,
        count: 1,
      },
    ]);
    if (selectedOffer?.offerCode) {
      offerApply(selectedOffer.offerCode, element.id);
    } else if (selectedCoupon?.couponId) {
      couponApply(selectedCoupon.code, selectedCoupon.couponId, element.id);
    }
  };
  const updateCarCount = (flag) => {
    if (flag) {
      setCarDetails((prevData) => {
        const data = [...prevData];
        if (data.length > 0) {
          data[0]["count"] = data[0]["count"] + 1;
        } else {
          data.push({
            id: element.id,
            count: 1,
          });
        }
        return data;
      });
    } else {
      setCarDetails((prevData) => {
        const data = [...prevData];
        if (data.length > 0) {
          data[0]["count"] = data[0]["count"] - 1;
        }
        return data;
      });
    }
  };

  return (
    <Card className="car-card">
      <button
        type="button"
        disabled={!carFareEstimate?.active}
        className={`btn car-select-button ${
          selectFlag ? "selected-car-active" : ""
        }`}
        onClick={() => selectCab()}
      >
        <div className="car-header">
          <span className="car-name">{element.name}</span>
          <div className="car-quantity">
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                updateCarCount(false);
              }}
              disabled={!selectFlag || noOfCars == 1 || editTrip}
            >
              -
            </button>
            <div>{noOfCars}</div>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                updateCarCount(true);
              }}
              disabled={!selectFlag || editTrip || (editTrip && noOfCars == 1)}
            >
              +
            </button>
          </div>
        </div>
        <div className="car-body">
          <div className="price-body">
            <div className="individual-price">
              <span>
                <i className="fa fa-rupee"></i>
              </span>
              <span
                className="fee-amount"
                style={{
                  textDecoration:
                    carFareEstimate?.discountedEstimateFare != null ||
                    (selectFlag && selectedCoupon && selectedCoupon?.discountedFinalFare != null) ||
                    (selectFlag && selectedOffer && selectedOffer?.finalFare != null)
                      ? "line-through"
                      : "none",
                }}
              >
                {carFareEstimate &&
                (carFareEstimate?.estimatedMinFare ||
                  carFareEstimate?.estimatedMinFare == 0)
                  ? carFareEstimate?.estimatedMinFare
                  : "****"}
              </span>
            </div>
            {(carFareEstimate?.discountedEstimateFare != null ||
              (selectFlag && selectedCoupon?.finalFare != null) ||
              (selectFlag && selectedOffer?.finalFare != null)) && (
              <div className="individual-price">
                <span>
                  <i className="fa fa-rupee"></i>
                </span>
                <span className="fee-amount">
                  {selectFlag && selectedCoupon?.finalFare != null
                    ? selectedCoupon.finalFare
                    : selectFlag && selectedOffer?.finalFare != null
                    ? selectedOffer.finalFare
                    : carFareEstimate.discountedEstimateFare}
                </span>
              </div>
            )}
          </div>
          <Image
            attrImage={{
              alt: element.name,
              src: element.iconUrl,
            }}
          />
        </div>
      </button>
    </Card>
  );
};

export default CabDetails;
